import { IChatBot } from '@/interfaces/user'
import Constants from '@/configs/constants'

export function LoadChat(chat?: IChatBot) {
  const isChatEnabled =
    chat?.profileName != 'Interno' &&
    chat?.passwordUser &&
    chat?.email &&
    !document.getElementById(Constants.SALESFORCE_REF)

  if (!isChatEnabled) return

  window.initEmbeddedMessaging = function () {
    try {
      embeddedservice_bootstrap.settings.language = 'pt_BR'

      window.addEventListener('onEmbeddedMessagingReady', () => {
        embeddedservice_bootstrap.prechatAPI.setHiddenPrechatFields({
          nomeAplicacao: 'Site VR',
          CNPJ: chat?.accountCnpj ?? '',
          Nome: chat?.userName ?? '',
          EmailLogin: chat?.email ?? '',
        })
      })

      embeddedservice_bootstrap.init(
        process.env.VITE_APP_SALESFORCE_ORG_ID,
        process.env.VITE_APP_SALESFORCE_DEPLOYMENT_NAME,
        process.env.VITE_APP_SALESFORCE_SITE_URL,
        {
          scrt2URL: process.env.VITE_APP_SALESFORCE_SCRT2_URL
        }
      )
    } catch (err) {
      console.error('Error loading Embedded Messaging: ', err)
    }
  }

  const script = document.createElement('script')
  script.id = Constants.SALESFORCE_REF
  script.type = 'text/javascript'
  script.src = process.env.VITE_APP_SALESFORCE_SCRIPT_URL
  script.onload = () => window.initEmbeddedMessaging()
  document.body.appendChild(script)
}
